import { useState } from 'react';
import { Popover, Avatar, List, Typography, App, Space } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { useAuthProfile } from 'feature/useProfile';

const { Text } = Typography;

const menuItems = [
  { key: 'view-profile', icon: <UserOutlined />, label: 'View Profile' },
  // { key: 'edit-profile', icon: <EditOutlined />, label: 'Edit Profile' },
  // { key: 'terms', icon: <FileTextOutlined />, label: 'Terms', href: '#' },
  // { key: 'privacy', icon: <LockOutlined />, label: 'Privacy', href: '#' },
  // {
  //   key: 'support',
  //   icon: <QuestionCircleOutlined />,
  //   label: 'Support',
  //   href: 'https://codedthemes.support-hub.io/'
  // },
  { key: 'logout', icon: <LogoutOutlined />, label: 'Logout', danger: true }
];

export default function Profile() {
  const [open, setOpen] = useState(false);
  const { logout } = useAuth();
  const { modal } = App.useApp();
  const navigate = useNavigate();
  const profileQuery = useAuthProfile();
  const profile = profileQuery.data;
  const displayName = profile?.name || profile?.fullName || 'My profile';
  const displayEmail = profile?.email || profile?.phone || '';
  const avatar = profile?.profileImage || undefined;
  const avatarInitial = displayName.charAt(0).toUpperCase();

  const handleLogout = () => {
    modal.confirm({
      title: 'Are you sure you want to logout?',
      okText: 'Logout',
      cancelText: 'Cancel',
      onOk: () => {
        logout();
      }
    });
  };

  const handleItemClick = (item) => {
    setOpen(false);

    if (item.key === 'logout') {
      handleLogout();
      return;
    }

    if (item.key === 'view-profile') {
      navigate('/profile');
      return;
    }

    if (item.href && item.href !== '#') {
      window.open(item.href, '_blank', 'noopener,noreferrer');
    }
  };

  const content = (
    <div style={{ width: 280 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <Avatar src={avatar} size={32} style={{ backgroundColor: '#81c21e', color: '#fff' }}>
          {!avatar && avatarInitial}
        </Avatar>
        <div>
          <Text strong style={{ display: 'block', fontSize: 13 }}>
            {displayName}
          </Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {displayEmail}
          </Text>
        </div>
      </div>

      <List
        size="small"
        dataSource={menuItems}
        renderItem={(item) => (
          <List.Item key={item.key} style={{ padding: '8px 0', cursor: 'pointer' }} onClick={() => handleItemClick(item)}>
            <List.Item.Meta avatar={item.icon} title={<Text type={item.danger ? 'danger' : undefined}>{item.label}</Text>} />
          </List.Item>
        )}
      />
    </div>
  );

  return (
    <Popover content={content} trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight">
      <div className="flex items-center gap-2 cursor-pointer">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', lineHeight: 1.3 }}>
          <span className="text-sm text-[#81c21e]">👋 Welcome,</span>
          <Text strong>{displayName}</Text>
        </div>
        <Avatar src={avatar} size={40} style={{ backgroundColor: '#81c21e', color: '#fff' }}>
          {!avatar && avatarInitial}
        </Avatar>
      </div>
    </Popover>
  );
}
